// extracted by mini-css-extract-plugin
var _1 = "_7M8h7";
var _2 = "gr93y";
var _3 = "cb2Ox";
export { _1 as "innerContentInnerPadding", _2 as "topAndBottomPaddingOnDesktop", _3 as "topAndBottomPaddingOnMobile" }
